import EmailInteractionEvent from "../../../email/controller/EmailInteractionEvent";
import SmartphoneNavigateEvent from "../../model/SmartphoneNavigateEvent";
import SmartphoneSkinKeyRegistry from "../../model/SmartphoneSkinKeyRegistry";
import AbstractSmartphoneMediator from "../AbstractSmartphoneMediator";

export default class SmartphoneEmailConversationScreenMediator extends AbstractSmartphoneMediator {

    constructor(target, dispatcher, mediatorManager, languagePack, soundManager) {
        super(target, dispatcher);

        this._mediatorManager = mediatorManager;
        this._languagePack = languagePack;
        this._soundManager = soundManager;

        this._conversation = this.getCustomData().conversation;

        this._smartphoneIsVisible = true;
    }

    initialize() {
        super.initialize();

        this._target.conversationList.customData = {
            conversation: this._conversation,
            skinKeyRegistry: SmartphoneSkinKeyRegistry
        };
        this._emailConversationMediator = this._mediatorManager.createMediator(this._target.conversationList, SmartphoneSkinKeyRegistry.EMAIL_CONVERSATION_SKIN);

        this._buttonClose = this.createInterfaceButton(this._target.closeButton, this._handleCloseButtonClick.bind(this));
        this._buttonBack = this.createInterfaceButton(this._target.backButton, this._handleBackButtonClick.bind(this));

        if (this._conversation.requiresReply()) {
            this._target.applicationTitleTextField.text = this._languagePack.getText("smartphone.email.draftTitle");
        } else {
            this._target.applicationTitleTextField.text = this._languagePack.getText("smartphone.email.title");
        }

        this.registerEventListener(EmailInteractionEvent.OPEN_DRAFT_CHOICE_PICKER, this._handleOpenDraftChoicePickerRequest.bind(this));
        this.registerEventListener(EmailInteractionEvent.CLOSE_DRAFT_CHOICE_PICKER, this._handleCloseDraftChoicePickerRequest.bind(this));
        this.registerEventListener(EmailInteractionEvent.SUBMIT_DRAFT, this._handleSubmitDraft.bind(this));

        this.registerEventListener(SmartphoneNavigateEvent.SMARTPHONE_SHOW_REQUEST, this._handleSmartphoneShowRequest.bind(this));
        this.registerEventListener(SmartphoneNavigateEvent.SMARTPHONE_HIDE_REQUEST, this._handleSmartphoneHideRequest.bind(this));
    }

    _handleSmartphoneShowRequest() {
        this._smartphoneIsVisible = true;
    }

    _handleSmartphoneHideRequest() {
        this._smartphoneIsVisible = false;
    }

    destroy() {
        super.destroy();

        this._emailConversationMediator.destroy();
    }

    //----------------------------
    //  Handlers
    //----------------------------

    _handleCloseButtonClick(evt) {
        const navEvt = new SmartphoneNavigateEvent(SmartphoneNavigateEvent.CLOSE_ALL_SCREENS_REQUEST);
        this.dispatch(navEvt.type, { data: navEvt });

        this.gotoScreen(SmartphoneSkinKeyRegistry.SMARTPHONE_MAIN_SCREEN_SKIN);
    }

    _handleBackButtonClick(evt) {
        this.closeScreen(this._target);
    }

    _handleOpenDraftChoicePickerRequest(evt) {
        if (!this._smartphoneIsVisible) {
            return;
        }

        const mcBlock = evt.params.mcBlock;

        this._draftChoicePickerScreen = this.openPopup(SmartphoneSkinKeyRegistry.EMAIL_DRAFT_OPTION_OVERLAY_SKIN, false, { needsOverlay: false }, {
            mcBlock,
            skinKeyRegistry: SmartphoneSkinKeyRegistry
        });
    }

    _handleCloseDraftChoicePickerRequest(evt) {
        if (!this._smartphoneIsVisible) {
            return;
        }

        if (this._draftChoicePickerScreen) {
            this.closePopup(this._draftChoicePickerScreen);
            this._draftChoicePickerScreen = null;
        }
    }

    _handleSubmitDraft(evt) {
        if (!this._smartphoneIsVisible) {
            return;
        }

        this.gotoScreen(SmartphoneSkinKeyRegistry.SMARTPHONE_EMAIL_BOX_SELECTION_SCREEN_SKIN);
    }
}